/**
 * Created by Andrey Popov on 08.10.2026
 */

const GameAnnounceConfig = {
    TARGETS: {
        ladacha: {
            sources: ["mergecraft", "fairy", "hustlemerge"]
        },
        garden: {
            sources: ["wondermerge"]
        }
    }
};

if (typeof module !== "undefined") {
    module.exports = GameAnnounceConfig;
}
